<div [ngSwitch]="activity.Content">
   
    <sc-activity-item-candidate-commented *ngSwitchCase="'#commented'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">        
    </sc-activity-item-candidate-commented>

    <sc-activity-item-candidate-reference-review *ngSwitchCase="'candidate_reference_review'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-candidate-reference-review>

    <sc-activity-item-candidate-reference-accepted *ngSwitchCase="'candidate_reference_accepted'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-candidate-reference-accepted>

    <sc-activity-item-candidate-reference-rejected *ngSwitchCase="'candidate_reference_rejected'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-candidate-reference-rejected>

    <sc-activity-item-candidate-accepted *ngSwitchCase="'#accepted'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-candidate-accepted>    

    <sc-activity-item-candidate-feedback-posted *ngSwitchCase="'#candidatefeedback'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-candidate-feedback-posted>

    <sc-activity-item-candidate-hired *ngSwitchCase="'#hired'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-candidate-hired>

    <sc-activity-item-candidate-rejected *ngSwitchCase="'#rejected'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-candidate-rejected>

    <sc-activity-item-candidate-shortlisted *ngSwitchCase="'#shortlistedcandidate'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">        
    </sc-activity-item-candidate-shortlisted>

    <sc-activity-item-candidate-added-to-pool *ngSwitchCase="'#candidateaddedtopool'" [activity]="activity" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-candidate-added-to-pool>

    <sc-activity-item-project-jobsite-commented *ngSwitchCase="'#jobsitecomment'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">
    </sc-activity-item-project-jobsite-commented>

    <sc-activity-item-project-jobsite-confirmed *ngSwitchCase="'#jobsiteconfirmed'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">
    </sc-activity-item-project-jobsite-confirmed>

    <sc-activity-item-project-jobsite-ready *ngSwitchCase="'#jobsiteready'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">
    </sc-activity-item-project-jobsite-ready>

    <sc-activity-item-project-jobsite-work-item-commented *ngSwitchCase="'#jobsiteworkitemcomment'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">
    </sc-activity-item-project-jobsite-work-item-commented>

    <sc-activity-item-project-messaging-done *ngSwitchCase="'#messagingdone'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">        
    </sc-activity-item-project-messaging-done> 

    <sc-activity-item-project-briefing-completed *ngSwitchCase="'#projectbriefingcompleted'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">
    </sc-activity-item-project-briefing-completed>

    <sc-activity-item-project-created *ngSwitchCase="'#projectcreated'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">
    </sc-activity-item-project-created>

    <sc-activity-item-project-profile-feedback *ngSwitchCase="'#profile_feedback_submitted'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">
    </sc-activity-item-project-profile-feedback>

    <sc-activity-item-project-analysis-requested *ngSwitchCase="'project_analysis_requested'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">
    </sc-activity-item-project-analysis-requested>

    <sc-activity-item-project-analysis-created *ngSwitchCase="'project_analysis_created'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language">
    </sc-activity-item-project-analysis-created>

    <sc-activity-item-company-pool-onboarding *ngSwitchCase="'company_pool_onboarding'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-company-pool-onboarding>

    <sc-activity-item-pool-signal *ngSwitchCase="'pool_signal'" [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [language]="language" [context]="context">
    </sc-activity-item-pool-signal>

</div>